/**
 * Shared material-blend clock. Parent advances `startedAt` in useLayoutEffect (after all
 * GlbModel layouts register), so Cap / Body never read a clock that already started mid-commit.
 */

let transitionKey = '';
let startedAt = Number.POSITIVE_INFINITY;
let durationSec = 0.4;

export function armMaterialTransitionClock(key: string, durationSeconds: number): void {
  if (key === transitionKey) return;
  transitionKey = key;
  durationSec = Math.max(0, durationSeconds);
  // Freeze until commitLayoutMaterialTransitionClock() after child layouts.
  startedAt = Number.POSITIVE_INFINITY;
}

export function commitLayoutMaterialTransitionClock(): void {
  if (!Number.isFinite(startedAt) || startedAt === Number.POSITIVE_INFINITY) {
    // Small buffer so late sibling layouts in the same commit still join at t≈0.
    startedAt = (typeof performance !== 'undefined' ? performance.now() : Date.now()) + 24;
  }
}

/** True after the player (or any host) has armed a shared blend — false in the editor. */
export function isMaterialTransitionClockActive(): boolean {
  return transitionKey !== '';
}

export function materialTransitionBlend(now = typeof performance !== 'undefined' ? performance.now() : Date.now()): {
  raw: number;
  t: number;
} {
  // Frozen (pre-commit) clock must hold at t=0 — returning t=1 made mid-swipe
  // restarts jump to the previous target (Cap appeared to “arrive” first).
  if (!(durationSec > 0) || !Number.isFinite(startedAt) || startedAt === Number.POSITIVE_INFINITY) {
    return { raw: 0, t: 0 };
  }
  const raw = Math.min(1, Math.max(0, (now - startedAt) / (durationSec * 1000)));
  // Smootherstep
  const x = raw;
  const t = x * x * x * (x * (x * 6 - 15) + 10);
  return { raw, t };
}

export function getMaterialTransitionStartedAt(): number {
  return startedAt;
}
